import { DisplayOption } from '../interface';

export interface PortalFAMOption {
  districts: Array<DisplayOption>;
  bienniums: Array<DisplayOption>;
  jobStatuses: Array<DisplayOption>;
  districtsCsvFields: Array<DisplayOption>;
  districtJobsCsvFields: Array<DisplayOption>;
  districtJobsPifAndMilestonesCsvFields: Array<DisplayOption>;
}
